import { func } from "../../../utils";
import { Button, Text } from "../../atoms";

export const LiveStreamingCard = ({ text, desc }) => {
  return (
    <>
      <div className="live-streaming">
        <img
          src={func.getStaticImg(`icon/sa-streaming.svg`)}
          alt={"streaming-icon"}
        />
        <div className="live-streaming__text">
          <Text
            className="live-streaming__text__title"
            weight="bold"
            color="white"
          >
            {text}
          </Text>
          <Text color="white">The Finals Piala by.U</Text>
        </div>
        <Button
          variant={"secondary-white"}
          size={"small"}
          className={"live-streaming__button"}
          onClick={() =>
            window.open("https://www.youtube.com/watch?v=qycW4VwHeAM", "_blank")
          }
        >
          Nonton
        </Button>
      </div>
    </>
  );
};
